import { Box } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Header from '../Header';
import SideBar from '../SideBar';
import { SidebarOption } from '../../interfaces/components';
import HomeIcon from '../../assets/Icons/Home';
import { useLocation } from 'react-router-dom';

export interface OverlayProps {
  children: React.ReactNode;
}

export const sidebarOptions: SidebarOption[] = [
  {
    href: '/',
    key: 'home',
    text: 'Home',
    sideBarIcon: <HomeIcon fill="currentColor" boxSize={[4]} />,
  },
];

function Overlay({ children }: OverlayProps) {
  const location = useLocation();
  const [activeView, setActiveView] = useState('home');

  useEffect(() => {
    const activeSidebarOption = sidebarOptions.find(
      (sidebarOption: SidebarOption) => sidebarOption.href === location.pathname,
    );

    activeSidebarOption ? setActiveView(activeSidebarOption.key) : setActiveView('');
  }, [location.pathname]);

  return (
    <Box w="100%" h="100vh" display="flex" flexDirection="column">
      <Header />
      <Box display="flex" h={['100%', '100%', '100%', 'calc(100vh - 77px)']}>
        <SideBar
          activeView={activeView}
          sidebarOptions={sidebarOptions}
          setActiveView={(view) => setActiveView(view)}
        />
        <Box background="#F5F5F5" w="100%" overflowY="auto">
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default Overlay;
